import { render } from "./GalleryGridItem.vue?vue&type=template&id=4670bb92&scoped=true"
import script from "./GalleryGridItem.vue?vue&type=script&lang=js"
export * from "./GalleryGridItem.vue?vue&type=script&lang=js"

import "./GalleryGridItem.vue?vue&type=style&index=0&id=4670bb92&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4670bb92"]])

export default __exports__